<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }" id="entityCollection">
    <div class="w-full">
      <el-form
        label-width="100px"
        ref="collectionForm"
        :rules="collectionFormRules"
        :model="collectionForm"
        label-position="right"
      >
        <el-row class="title-box w-full flex" :gutter="10">
          <el-col :span="5">
            <el-form-item label="标准" prop="standardId">
              <selectStandardId @updateStandardId="updateStandardId" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('实体')" prop="classId">
              <el-select
                v-model="collectionForm.classId"
                clearable
                filterable
                :placeholder="$t('pleaseSelect')"
                size="small"
              >
                <el-option
                  v-for="item in classList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('归类属性')" prop="classAttirbuteId">
              <el-select
                v-model="collectionForm.classAttirbuteId"
                clearable
                filterable
                :placeholder="$t('pleaseSelect')"
                size="small"
              >
                <el-option
                  v-for="item in attributeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('实体集名称')" prop="name">
              <el-input size="small" clearable v-model.trim="collectionForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button
              :disabled="!$hasAccess('create')"
              type="primary"
              @click="add"
              :loading="btnLoading"
              class="ml-10px"
              >{{ $t('create') }}</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row class="flex cardBox mt-20px">
      <el-col :span="7" class="h-full">
        <el-card class="box-card h-full" v-loading="entityAttrLoading">
          <div slot="header" class="justify-center items-center flex">
            <span>{{ $t('归类实体属性') }}</span>
            <el-button :disabled="!$hasAccess('delete')" type="danger" size="mini" @click="del">{{
              $t('delete')
            }}</el-button>
          </div>
          <el-input
            :placeholder="$t('pleaseEnter')"
            @keydown.enter.native="getEntityAttrList"
            v-model="entityAttrKeyword"
          >
            <i slot="suffix" class="el-input__icon el-icon-search" @click="getEntityAttrList"></i>
          </el-input>
          <el-radio-group
            v-model="entityAttr"
            class="w-full mt-10px radioGroup"
            @change="changeEntityAttr"
          >
            <el-radio
              :label="item.id"
              v-for="(item, index) in entityAttrList"
              :key="index"
              class="mt-10px w-full"
              >{{ item.titleName }}</el-radio
            >
          </el-radio-group>
        </el-card>
      </el-col>
      <el-col :span="1" class="h-full flex iconBox">
        <i class="iconfont icon-line-circleRightArrow text-40px font-bold"></i>
      </el-col>
      <el-col :span="8" class="h-full">
        <el-card class="box-card h-full" v-loading="entityAttrValLoading">
          <div slot="header" class="justify-center items-center flex">
            <span>{{ $t('归类实体属性值') }}</span>
          </div>
          <el-input
            placeholder="请输入内容"
            @keydown.enter.native="getClassAttributeValue"
            v-model="entityAttrValKeyword"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="getClassAttributeValue"
            ></i>
          </el-input>
          <el-radio-group
            v-model="entityAttrVal"
            @change="changeEntityAttrVal"
            class="w-full mt-10px radioGroupCenter"
          >
            <el-radio
              :label="item.attributeValue"
              v-for="(item, index) in entityAttrValList"
              :key="index"
              class="w-full mt-10px"
              >{{ item.attributeValue }}</el-radio
            >
          </el-radio-group>
          <el-pagination
            v-if="entityAttrValList.length"
            class="mt-10px r w-full"
            background
            :small="true"
            @current-change="getClassAttributeValue"
            @size-change="getClassAttributeValue"
            :current-page.sync="pageNo"
            :page-size.sync="pageSize"
            :page-sizes="[15, 30, 50]"
            layout="->, total, sizes, prev, pager, next"
            :total="recordCount"
          >
          </el-pagination>
        </el-card>
      </el-col>
      <el-col :span="1" class="h-full flex iconBox">
        <i class="iconfont icon-line-circleRightArrow text-40px font-bold"></i>
      </el-col>
      <el-col :span="7" class="h-full">
        <el-card class="box-card h-full" v-loading="referenceClassLoading">
          <div slot="header" class="justify-center items-center flex">
            <span>{{ $t('引用实体列表') }}</span>
            <el-button
              :disabled="!$hasAccess('save')"
              type="primary"
              size="mini"
              @click="save"
              :loading="saveBtnLoading"
              >保存</el-button
            >
          </div>
          <el-input
            :placeholder="$t('pleaseEnter')"
            @keydown.enter.native="getReferenceClass"
            v-model="referenceClassKeyword"
          >
            <i slot="suffix" class="el-input__icon el-icon-search" @click="getReferenceClass"></i>
          </el-input>
          <el-checkbox-group v-model="checkList" class="w-full mt-10px radioGroup">
            <el-checkbox
              class="w-full mt-10px"
              :label="item.id"
              v-for="(item, index) in referenceClassList"
              :key="index"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-card>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import StdClassTreeService from '@/services/bsApi/StdClassTreeService'
import stdClassListService from '@/services/stdClassListService'
import StdClassNotionalpoolingService from '@/services/bsApi/StdClassNotionalpoolingService'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'entityCollection',
  components: { selectStandardId },
  data() {
    return {
      collectionFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        classId: [{ required: true, message: '请选择', trigger: 'blur' }],
        standardId: [{ required: true, message: '请选择', trigger: 'blur' }],
        classAttirbuteId: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      collectionForm: {
        classId: '',
        standardId: localStorage.getItem('standardId'),
        classAttirbuteId: '',
        name: '',
      },
      classId: '',
      classList: [],
      attributeList: [],
      btnLoading: false,
      saveBtnLoading: false,
      selectedId: '',
      entityAttr: '',
      entityAttrVal: '',
      checkList: [],
      entityAttrList: [],
      entityAttrKeyword: '',
      entityAttrLoading: false,
      selectedEntityAttrId: '',
      entityAttrValList: [],
      entityAttrValKeyword: '',
      entityAttrValLoading: false,
      selectedEntityAttrValId: '',
      referenceClassList: [],
      referenceClassKeyword: '',
      referenceClassLoading: false,
      pageNo: 1,
      pageSize: 15,
      recordCount: 0,
    }
  },
  watch: {
    uploadFileVisible(bol) {
      if (!bol) {
        this.isFullScreen = false
        this.uploadFileTitle = '上传'
      }
    },
    // 标准变化请求实体
    'collectionForm.standardId': {
      handler(val) {
        this.collectionForm.classId = ''
        this.classList = []
        this.collectionForm.classAttirbuteId = ''
        this.attributeList = []
        if (val) {
          this.getClassList()
        }
      },
    },
    // 实体变化请求属性列表
    'collectionForm.classId': {
      handler(val) {
        this.collectionForm.classAttirbuteId = ''
        this.attributeList = []
        if (val) {
          this.getAttrList()
          this.getEntityAttrList()
        }
      },
    },
    // 属性变化请求明细列表
    // attrId(val) {
    //   if (val) {
    //   }
    // },
  },
  async created() {
    this.getEntityAttrList()
    if (this.collectionForm.standardId) {
      this.getClassList()
    }
  },
  activated() {
    this.collectionForm.standardId = localStorage.getItem('standardId')
  },
  methods: {
    updateStandardId(val) {
      this.collectionForm.standardId = val
    },
    // 获取实体列表
    async getClassList() {
      const parameter = {
        data_type: 1,
        standard_id: this.collectionForm.standardId,
      }
      const res = await StdClassTreeService.getTreeList(parameter)
      if (res && res.code === 0 && res.data) {
        // 过滤出已经发布的实体
        this.classList = res.data.filter((item) => {
          return item.approveStatus === 1
        })
        if (this.classList.length) {
          this.collectionForm.classId = this.classList[0].id
        }
      }
    },
    // 获取属性列表
    async getAttrList() {
      const parameter = {
        class_id: this.collectionForm.classId,
      }
      const res = await stdClassListService.getAttrList(parameter)
      if (res && res.code === 0 && res.data) {
        this.attributeList = res.data
        if (this.attributeList.length) {
          this.collectionForm.classAttirbuteId = this.attributeList[0].id
        }
      }
    },
    // 获取归类实体属性列表
    async getEntityAttrList() {
      this.entityAttrLoading = true
      const parameter = {
        keyword: this.entityAttrKeyword,
        standard_id: this.collectionForm.standardId,
      }
      const res = await StdClassNotionalpoolingService.entityAttrList(parameter)
      if (res && res.code === 0 && res.data) {
        this.entityAttrList = res.data
      }
      this.entityAttrLoading = false
    },
    add() {
      this.$refs.collectionForm.validate(async (valid) => {
        if (valid) {
          const parameter = {
            model: this.collectionForm,
          }
          this.btnLoading = true
          const res = await StdClassNotionalpoolingService.create(parameter)
          if (res && res.code === 0 && res.data) {
            this.collectionForm.name = ''
            this.getEntityAttrList()
            this.$message({
              message: '新增成功',
              type: 'success',
            })
          }
        }
        this.btnLoading = false
      })
    },
    del() {
      if (!this.selectedEntityAttrId) {
        this.$message({
          message: '请先选择归类实体属性',
          type: 'warning',
        })
        return
      }
      this.$confirm('是否确定要删除该归类实体属性！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await StdClassNotionalpoolingService.remove([this.selectedEntityAttrId])
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              message: '删除归类实体属性成功！',
            })
            this.getEntityAttrList()
            this.entityAttrValList = []
            this.referenceClassList = []
            this.selectedEntityAttrId = ''
          }
        })
        .catch(() => {})
    },
    changeEntityAttr(val) {
      this.selectedEntityAttrId = val
      this.getClassAttributeValue()
      this.referenceClassList = []
    },
    async getClassAttributeValue() {
      if (!this.selectedEntityAttrId) {
        this.$message({
          message: '请先选择归类实体属性',
          type: 'warning',
        })
        return
      }
      this.entityAttrValLoading = true
      const parameter = {
        keyword: this.entityAttrValKeyword,
        id: this.selectedEntityAttrId,
        pageno: this.pageNo,
        pagesize: this.pageSize,
      }
      const res = await StdClassNotionalpoolingService.getClassAttributeValue(parameter)
      if (res && res.code === 0 && res.data) {
        this.entityAttrValList = res.data
        if (res.page) {
          this.recordCount = res.page.recordCount
          this.pageNo = res.page.pageNo
          this.pageSize = res.page.pageSize
        }
      }
      this.entityAttrValLoading = false
    },
    changeEntityAttrVal(val) {
      this.selectedEntityAttrValId = val
      this.getReferenceClass()
    },
    async getReferenceClass() {
      if (this.selectedEntityAttrValId === '' || this.selectedEntityAttrValId === null) {
        this.$message({
          message: '请先选择归类实体属性值',
          type: 'warning',
        })
        return
      }
      this.referenceClassLoading = true
      const parameter = {
        keyword: this.referenceClassKeyword,
        id: this.selectedEntityAttrId,
        attributevalue: this.selectedEntityAttrValId,
      }
      const res = await StdClassNotionalpoolingService.getReferenceClass(parameter)
      if (res && res.code === 0 && res.data) {
        this.referenceClassList = res.data
        this.checkList = this.referenceClassList.map((item) => {
          if (item.isTabCheck) {
            return item.id
          }
        })
      }
      this.referenceClassLoading = false
    },
    async save() {
      if (!this.checkList.length) {
        this.$message({
          message: '请先选择引用实体列表项',
          type: 'warning',
        })
        return
      }
      this.saveBtnLoading = true
      const parameter = {
        classNotionalpoolingId: this.selectedEntityAttrId,
        classAttributeValue: this.selectedEntityAttrValId,
        referenceClassId: this.checkList,
      }
      const res = await StdClassNotionalpoolingService.saveRelation(parameter)
      if (res && res.code === 0 && res.data) {
        this.$message({
          message: '保存成功',
          type: 'success',
        })
      }
      this.saveBtnLoading = false
    },
  },
}
</script>
<style lang="scss" scoped>

#entityCollection {
  .addEntityCollection {
    border: 1px solid #dcdcdc;
    .addBtn {
      justify-content: flex-end;
    }
  }
  .cardBox {
    justify-content: center;
    align-items: center;
    height: calc(100% - 56px);
    .iconBox {
      justify-content: center;
      align-items: center;
    }
    .clearfix {
      justify-content: space-between;
      align-items: center;
    }
    .radioGroup {
      overflow-y: auto;
      height: calc(100vh - 415px);
    }
    .radioGroupCenter {
      overflow-y: auto;
      height: calc(100vh - 445px);
    }
  }
  .el-radio {
    margin-right: 0px !important;
  }
  .el-checkbox {
    margin-right: 0px !important;
  }
  .el-pagination {
    overflow-x: auto;
    overflow-y: hidden;
    height: 50px;
  }
  /deep/.el-form-item__label {
    text-align: right;
  }
  .title-box /deep/.el-form-item {
    margin-bottom: 0px !important;
  }
}

</style>
